import { observer } from 'mobx-react';
import {
  CheckboxItem,
  RadioItem,
  SelectItem,
  InputItem,
  PasswordItem,
  BaseItem,
} from '@/components/FormItem';
import FormCommon from '@/components/FormCommon';
import ICEContacts from './ICEContacts';
import { usePhonebook } from '@/store';
import { $fm } from '@/Intl';

export default observer(() => {
  const [phonebook, updatePhonebook, defaults] = usePhonebook();

  return (
    <FormCommon
      initialValues={phonebook}
      defaults={defaults}
      onUpdate={updatePhonebook}
    >
      <h3 className='sub-title'>{$fm('IMPORT')}</h3>
      <CheckboxItem label={$fm('CLEAR_OLD_LIST')} name='importClearOld' />
      {/* 清除旧记录模式 */}
      <RadioItem
        label={$fm('CLEAR_OLD_LIST_MODE')}
        name='importClearOldMode'
        depends={{
          importClearOld: 1,
        }}
        options={[
          { v: 0, t: $fm('CLEAR_ALL') },
          { v: 1, t: $fm('KEEP_LOCAL_CONTACTS') },
        ]}
      />
      {/* 替换重复的条目 */}
      <CheckboxItem label={$fm('REPLACE_DUP')} name='importRmRedup' />
      {/* 替换重复条目模式 */}
      <RadioItem
        label={$fm('REPLACE_DUP_MODE')}
        name='importRmRedupMode'
        depends={{
          importRmRedup: 1,
        }}
        options={[
          { v: 0, t: $fm('REPLACE_BY_NAME') },
          { v: 1, t: $fm('REPLACE_BY_NUMBER') },
        ]}
      />
      {/* 导入文件编码 */}
      <SelectItem
        label={$fm('FILE_ENCODE')}
        name='importFileEncoding'
        options={[
          { t: 'UTF-8', v: 'UTF-8' },
          { t: 'GBK', v: 'GBK' },
          { t: 'UTF-16', v: 'UTF-16' },
          { t: 'UTF-32', v: 'UTF-32' },
          { t: 'Big5', v: 'Big5' },
          { t: 'Big5-HKSCS', v: 'Big5-HKSCS' },
          { t: 'SHIFT-JIS', v: 'SHIFT-JIS' },
          { t: 'ISO8859-1', v: 'ISO8859-1' },
          { t: 'ISO8859-15', v: 'ISO8859-15' },
          { t: 'Windows-1251', v: 'Windows-1251' },
          { t: 'EUC-KR', v: 'EUC-KR' },
        ]}
      />
      {/* 导入文件类型 */}
      <SelectItem
        label={$fm('FILE_TYPE')}
        name='importFileType'
        options={[
          { t: 'XML', v: 0 },
          { t: 'VCard', v: 1 },
        ]}
      />
      <h3 className='sub-title'>{$fm('EXPORT')}</h3>
      {/* 导出文件编码 */}
      <SelectItem
        label={$fm('FILE_ENCODE')}
        name='exportFileEncoding'
        options={[
          { t: 'UTF-8', v: 'UTF-8' },
          { t: 'GBK', v: 'GBK' },
          { t: 'UTF-16', v: 'UTF-16' },
          { t: 'UTF-32', v: 'UTF-32' },
          { t: 'Big5', v: 'Big5' },
          { t: 'Big5-HKSCS', v: 'Big5-HKSCS' },
          { t: 'SHIFT-JIS', v: 'SHIFT-JIS' },
          { t: 'ISO8859-1', v: 'ISO8859-1' },
          { t: 'ISO8859-15', v: 'ISO8859-15' },
          { t: 'Windows-1251', v: 'Windows-1251' },
          { t: 'EUC-KR', v: 'EUC-KR' },
        ]}
      />
      {/* 导出文件类型 */}
      <SelectItem
        label={$fm('FILE_TYPE')}
        name='exportFileType'
        options={[
          { t: 'XML', v: 0 },
          { t: 'VCard', v: 1 },
        ]}
      />
      <h3 className='sub-title'>{$fm('DOWNLOAD')}</h3>
      {/* 清除旧列表 */}
      <CheckboxItem label={$fm('CLEAR_OLD_LIST')} name='downloadClearOld' />
      {/* 清除旧记录模式 */}
      <RadioItem
        label={$fm('CLEAR_OLD_LIST_MODE')}
        name='downloadClearOldMode'
        depends={{
          downloadClearOld: 1,
        }}
        options={[
          { v: 0, t: $fm('CLEAR_ALL') },
          { v: 1, t: $fm('KEEP_LOCAL_CONTACTS') },
        ]}
      />
      {/* 替换重复的条目 */}
      <CheckboxItem label={$fm('REPLACE_DUP')} name='downloadRmRedup' />
      {/* 替换重复条目模式 */}
      <RadioItem
        label={$fm('REPLACE_DUP_MODE')}
        name='downloadRmRedupMode'
        depends={{
          downloadRmRedup: 1,
        }}
        options={[
          { v: 0, t: $fm('REPLACE_BY_NAME') },
          { v: 1, t: $fm('REPLACE_BY_NUMBER') },
        ]}
      />
      {/* 下载模式 */}
      <RadioItem
        label={$fm('DOWNLOAD_MODE')}
        name='downloadMode'
        options={[
          { v: 0, t: $fm('DOWNLOAD_MODE_OFF') },
          { v: 1, t: 'TFTP' },
          { v: 2, t: 'HTTP' },
          { v: 3, t: 'HTTPS' },
        ]}
      />
      {/* 下载服务器 */}
      <InputItem label={$fm('DOWNLOAD_SERVER')} name='downloadUrl' />
      {/* 自动下载周期 ?? */}
      <SelectItem
        label={$fm('AUTO_DOWNLOAD_INTERFAL')}
        name='updateInterval'
        options={[
          { t: $fm('NONE'), v: 0 },
          { t: $fm('MINUTES', { n: '5' }), v: 5 },
          { t: $fm('MINUTES', { n: '30' }), v: 30 },
          { t: $fm('HOUR', { n: '1' }), v: 60 },
          { t: $fm('HOURS', { n: '2' }), v: 120 },
          { t: $fm('HOURS', { n: '4' }), v: 240 },
          { t: $fm('HOURS', { n: '6' }), v: 360 },
          { t: $fm('HOURS', { n: '8' }), v: 480 },
          { t: $fm('HOURS', { n: '12' }), v: 720 },
        ]}
      />
      {/* 下载文件编码 */}
      <SelectItem
        label={$fm('FILE_ENCODE')}
        name='downloadFileEncoding'
        options={[
          { t: 'UTF-8', v: 'UTF-8' },
          { t: 'GBK', v: 'GBK' },
          { t: 'UTF-16', v: 'UTF-16' },
          { t: 'UTF-32', v: 'UTF-32' },
          { t: 'Big5', v: 'Big5' },
          { t: 'Big5-HKSCS', v: 'Big5-HKSCS' },
          { t: 'SHIFT-JIS', v: 'SHIFT-JIS' },
          { t: 'ISO8859-1', v: 'ISO8859-1' },
          { t: 'ISO8859-15', v: 'ISO8859-15' },
          { t: 'Windows-1251', v: 'Windows-1251' },
          { t: 'EUC-KR', v: 'EUC-KR' },
        ]}
      />
      {/* HTTP/HTTPS用户名 */}
      <InputItem
        label={$fm('HTTP_HTTPS_USERNAME')}
        name='downloadUsername'
        depends={{
          downloadMode: [0, 2, 3],
        }}
      />
      {/* HTTP/HTTPS密码 */}
      <PasswordItem
        label={$fm('HTTP_HTTPS_PASSWORD')}
        name='downloadPassword'
        depends={{
          downloadMode: [0, 2, 3],
        }}
      />
      <h3 className='sub-title'>{$fm('CONTACTS')}</h3>
      <BaseItem label={$fm('ICE_CONTACT')} name='iceNumber'>
        <ICEContacts />
      </BaseItem>
    </FormCommon>
  );
});
